import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ProgressBar, { ProgressContainer } from 'components/ProgressBar';

import { InstallButtonState } from '../../constants';

import { Button } from 'components/Button/Common';
import { fitbitPink } from 'themes';
import { isiOS } from 'config';

const { NOT_INSTALLED, INSTALLED, DISABLED, UNINSTALL } = InstallButtonState;

export const PinkButton = styled(Button)`
  background-color: ${fitbitPink};
  color: white;
  -webkit-tap-highlight-color: transparent;
`;

const PinkBorderButton = styled(Button)`
  border: 1px solid ${fitbitPink};
  color: ${fitbitPink};
  -webkit-tap-highlight-color: transparent;
`;

export const DisabledButton = styled(Button)`
  background-color: #fafafa;
  border-radius: ${({ theme }) => theme.buttonRadius};
  color: #bababa;
`;

/* @FIXME Add this back when cancel is fixed
const CancelContainer = styled.div`
  color: #C3C8C9;
  font-size: 12px;
  margin-top: 12px;
  text-align: center;
`;
*/

export const LoadingBar = () => (
  <ProgressContainer>
    <ProgressBar animation={true} />
  </ProgressContainer>
);

export const Progress = ({ progress }) => (
  <div>
    <ProgressContainer>
      <ProgressBar percentage={progress ? progress : 0} />
    </ProgressContainer>
    {/* @FIXME Disable cancel because it doesn't work correctly
    {onUninstall &&
      <CancelContainer onClick={this.onUninstall}>
        Tap to Cancel
      </CancelContainer>
    */}
  </div>
);

export const NormalInstallButton = PinkButton;

export default class InstallButton extends Component {
  static propTypes = {
    app: PropTypes.shape().isRequired,
    showRemove: PropTypes.bool,
    texts: PropTypes.shape().isRequired,
    onInstall: PropTypes.func,
    onUninstall: PropTypes.func
  };

  onInstall = (event) => {
    event.preventDefault();
    const { onInstall } = this.props;
    onInstall();
  };

  onUninstall = (event) => {
    event.preventDefault();
    const { onUninstall } = this.props;
    onUninstall();
  };

  render() {
    const { app, loading, onUninstall, showRemove, texts } = this.props;

    if (app.showProgress) {
      return <Progress progress={app.progress} />;
    }

    if (
      app.isPending ||
      app.isPendingRemoval ||
      (loading && app.isInstalling) ||
      (app.isClock && app.isSelected && !app.isActive)
    ) {
      return <LoadingBar />;
    }

    if (app.hasUpdateAvailable) {
      return (
        <NormalInstallButton
          data-test-type="install-button"
          onClick={this.onInstall}
        >
          {texts[app.installStatus]}
        </NormalInstallButton>
      );
    }

    if (app.isOnDevice) {
      if (!isiOS && onUninstall && showRemove) {
        return (
          <PinkBorderButton
            data-test-type="uninstall-button"
            onClick={this.onUninstall}
          >
            {texts[UNINSTALL]}
          </PinkBorderButton>
        );
      }

      if (app.type === 'APP' || app.type === 'SERVICE' || app.isActive) {
        return <DisabledButton>{texts[INSTALLED]}</DisabledButton>;
      }
    }

    if (app.hasNoVersionAvailable || app.cannotInstallOnDevice) {
      return <DisabledButton>{texts[DISABLED]}</DisabledButton>;
    }

    return (
      <NormalInstallButton
        data-test-id="install-button"
        onClick={this.onInstall}
      >
        {texts[NOT_INSTALLED]}
      </NormalInstallButton>
    );
  }
}
